import { FunctionalComponent, h } from '@stencil/core';

interface LogoProps {
    /**
     * URL to navigate to when logo is clicked
     */
    href?: string;
    /**
     * Additional CSS classes to apply to the logo container
     */
    className?: string;
    /**
     * Title attribute for the logo
     */
    title?: string;
}

export const Logo: FunctionalComponent<LogoProps> = () => {
    return (
        <a href="/en" class="e-header__logo e-header-top-item" title="Ericsson logo">
            <i class="icon icon-econ"></i>
            <svg
                version="1.1"
                x="0px"
                y="0px"
                viewBox="0 0 1500 304"
                xmlSpace="preserve"
            >
                <g>
                    <polygon points="3,94.7 124,94.7 124,127.6 45.8,127.6 45.8,156.2 120.8,156.2 120.8,190.4 45.8,190.4 45.8,219.9 125.3,219.9 125.3,253.1 3,253.1" />
                    <polygon points="312.3,94.7 355.4,94.7 355.4,253.2 312.3,253.2" />
                    <path d="M512.7,99.8l-2.9,33.9c-34.8-20.2-88.2-13.7-89.1,39.1c-1,52.8,55,60.5,90.4,42.6l2.2,34.6c-62.6,19.5-137.4-0.3-137.1-77.2C376.5,97.5,451.9,76.7,512.7,99.8L512.7,99.8z" />
                    <path d="M639.6,97.3l-2.9,33c-21.7-12-63-12.3-63,6.5c0,27.8,73.5,7.7,73.5,67.3c0,58.6-70,59.2-115.4,45.7l3.2-34.9c28.4,13.3,68.7,16.2,68.7-6.8c0-25.2-73.8-11-73.8-67.7C529.9,93.9,587.5,81.5,639.6,97.3L639.6,97.3z" />
                    <path d="M769.6,97.3l-2.9,33c-21.7-12-63-12.3-63,6.5c0,27.8,73.5,7.7,73.5,67.3c0,58.6-70,59.2-115.4,45.7l3.2-34.9c28.4,13.3,68.7,16.2,68.7-6.8c0-25.2-73.8-11-73.8-67.7C660,93.9,717.5,81.5,769.6,97.3L769.6,97.3z" />
                    <polygon points="968.1,94.7 1022.7,94.7 1074.7,196.9 1074.7,94.7 1114.4,94.7 1114.4,253.2 1062.9,253.2 1008.1,149 1008.1,253.2 968.1,253.2" />
                    <path d="M868.7,90.9c44.8,0,78.9,26.2,78.9,83.4c0,54.7-34.3,82.8-78.9,82.8c-44.5,0-78.7-27.5-78.7-82.8C790.1,117.1,824,90.9,868.7,90.9L868.7,90.9z M834.2,174.3c0,24.2,10.4,51.5,34.5,51.5c24.2,0,34.3-27.3,34.5-51.5c0.2-21.8-10.3-51.4-34.5-51.5C844.6,122.8,834.2,150.1,834.2,174.3L834.2,174.3z" />
                    <path d="M196.6,161.5h23.6c10.6,0.2,20.2-6.2,20.1-17.9c-0.1-10.4-8.6-17.7-19.5-17.6h-24.3L196.6,161.5L196.6,161.5z M155.3,94.7H233c21.1,0,50.5,9.3,50.5,42.2c0,21.1-9.6,32.9-27.7,38.3c0.8-0.1,10.4,4.1,14.3,16c0.2,0.4,22.2,61.9,22.5,62h-45.8l-16.3-47.6c-2.5-7.3-7.9-12.2-15.7-12.2c-6.7,0-17.3-0.4-17.3,0v59.8h-42.2V94.7L155.3,94.7z" />
                </g>
                <g>
                    <path d="M1495.5,21.9c-2.5-7.7-8-13.7-14.8-17.1c-6.8-3.4-14.8-4.2-28.2,0.3l-151.6,50.5c-13.3,4.4-19.3,9.9-22.7,16.7s-4.2,14.8-1.6,22.6c2.5,7.7,8,13.7,14.8,17.1c6.8,3.4,14.8,4.2,28.2-0.3l151.6-50.5c13.3-4.4,19.3-9.9,22.7-16.7C1497.3,37.7,1498.1,29.7,1495.5,21.9z" />
                    <path d="M1495.5,115.5c-2.5-7.7-8-13.7-14.8-17.1c-6.8-3.4-14.8-4.2-28.2,0.3l-151.6,50.5c-13.3,4.4-19.3,9.9-22.7,16.7c-3.4,6.8-4.2,14.8-1.6,22.6c2.5,7.7,8,13.7,14.8,17.1c6.8,3.4,14.8,4.2,28.2-0.3l151.6-50.5c13.3-4.4,19.3-9.9,22.7-16.7C1497.3,131.3,1498.1,123.3,1495.5,115.5z" />
                    <path d="M1495.5,209.1c-2.5-7.7-8-13.7-14.8-17.1c-6.8-3.4-14.8-4.2-28.2,0.3l-151.6,50.5c-13.3,4.4-19.3,9.9-22.7,16.7c-3.4,6.8-4.2,14.8-1.6,22.6c2.5,7.7,8,13.7,14.8,17.1s14.8,4.2,28.2-0.3l151.6-50.5c13.3-4.5,19.3-9.9,22.7-16.7C1497.3,224.9,1498.1,216.9,1495.5,209.1z" />
                </g>
            </svg>
        </a>
    );
};